// src/services/uploadService.js

import { collection, setDoc, doc } from "firebase/firestore";
import { db } from "../firebaseConfig";

// Función para subir un JSON a la colección `serviciosclinica` en Firebase
async function uploadJsonToFirestore(data, fileName) {
  try {
    // Usamos el nombre del archivo como ID del documento en Firebase
    await setDoc(doc(collection(db, "serviciosclinica"), fileName), data);
    console.log(`Archivo ${fileName} subido exitosamente a Firebase`);
  } catch (error) {
    console.error(`Error al subir ${fileName}:`, error);
  }
}

// Función para procesar una lista de archivos JSON cargados desde el frontend y subirlos a Firebase
async function uploadFiles(files) {
  try {
    for (const file of files) {
      const fileContent = await file.text(); // Leer el contenido del archivo como texto
      const data = JSON.parse(fileContent); // Parsear el contenido JSON
      const fileName = file.name.replace(".json", ""); // Nombre del archivo sin extensión
      await uploadJsonToFirestore(data, fileName);
    }
    console.log("Todos los archivos JSON fueron subidos exitosamente.");
  } catch (error) {
    console.error("Error al procesar o subir los archivos JSON:", error);
  }
}

export { uploadFiles };
